import { onMessage } from "firebase/messaging";
import { messaging } from "./config/firebaseConfig";

export const setupOnMessageListener = (onNotification) => {
  // Check if messaging is available before setting up the listener
  if (!messaging) {
    console.warn("Firebase Cloud Messaging is not available");
    return;
  }

  onMessage(messaging, (payload) => {
    if (onNotification) {
      onNotification(payload.notification);
    }

    // Handle the System Notification
    if (Notification.permission === "granted") {
      // Check if service workers are supported
      if ('serviceWorker' in navigator) {
        navigator.serviceWorker.ready
          .then((registration) => {
            // Use showNotification instead of new Notification
            registration.showNotification(payload.notification.title, {
              body: payload.notification.body,
              icon: payload.notification.icon,
              // You can pass other options here like 'data', 'tag', etc.
            });
          })
          .catch((error) => {
            console.error("Service Worker registration failed:", error);
          });
      } else {
        // Fallback for browsers that support Notification but not SW (rare nowadays)
        new Notification(payload.notification.title, {
          body: payload.notification.body,
          icon: payload.notification.icon,
        });
      }
    }
  });
};